//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import {
    getOrderInfo
  } from '../api/cart-order-detail.js'
  import Api from '../api.js'
  import Vue from 'vue'
  import {isAlipayOrWechat} from '../utils/common.js'

  export default {
    data() {
      return {
        code : null,//订单编号
        orderInfo : {}, //订单详情信息
        imagesUrl: Api.imgUrl,
        maxNum:3,
        nextOrderInfoTime:null,
      };
    },
    created() {
      console.log("1111111111")
    },
    mounted: function() {
      console.log("2222222")
      this.code = this.$route.query.code;
      this.getOrderInfoFun()
    },
    methods: {
      test:function(){

      },
      //获取订单详情
      getOrderInfoFun: function() {

        if(this.maxNum <= 0){
          console.log("停止了")
          clearTimeout(this.nextOrderInfoTime);
        }
        let that = this;
        getOrderInfo(this.code).then(res => {
          console.log("返回--------", res)
          if (res.code == 1) {
            if(that.maxNum > 0 && res.data == ""){
              that.maxNum --;
              console.log("maxNum-------",that.maxNum)
              that.nextOrderInfoTime = setTimeout(that.getOrderInfoFun, 2000);
            }else{
              that.orderInfo = res.data;//订单详情信息
            }

          }
        })
      },
      //取消订单
      orderCancelFun:function(code){
        orderCancel(code).then(res => {
          console.log("返回--------", res)
          if (res.code == 1) {
            this.orderList = [];
            this.lastId = 0;
            this.getOrderListFun();//获取订单列表
          }
        })
      },

      //支付订单
      orderPayFun:function(code){
        let method = isAlipayOrWechat();
        if(method == "wx"){
          location.href = Api.wechatcart + '?code=' + code;
        }else{
          //支付宝
          location.href = Api.alicart + '?code=' + code;
        }
      },
      //跳转到父单详情
      gotoParentOrderFun:function(code,status){
       //已支付的订单才可以跳转到父订单
        if(status == 3 || status == "3"){
          location.href = Api.tradeUrl + '/order/detail/mall/' + code;
        }
      }

    },
    filters: {
      //时间戳转日期格式
      dateFormat: function(dataStr) {
        var time = new Date(dataStr);

        function timeAdd0(str) {
          if (str < 10) {
            str = '0' + str;
          }
          return str
        }
        var y = time.getFullYear();
        var m = time.getMonth() + 1;
        var d = time.getDate();
        var h = time.getHours();
        var mm = time.getMinutes();
        var s = time.getSeconds();
        return y + '-' + timeAdd0(m) + '-' + timeAdd0(d);
      }
    }
  }



// WEBPACK FOOTER //
// ./src/view/cart-order-detail.vue